import { useState } from "react";
import { Collapse, Flex, Text, Box } from "@chakra-ui/react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import CardDefault from "components/Cards/CardDefault";
import colors from "core/resources/theme/colors";

interface CollapsibleCardProps {
  titleCard: string;
  children: any;
}

export default function CollapsibleCard({
  titleCard,
  children,
}: CollapsibleCardProps) {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <CardDefault pb={4} overflow="visible">
      <Flex
        justifyContent='space-between'
        mb={2}
        px={0.5}
        cursor="pointer"
        onClick={() => setCollapsed((state) => !state)}
      >
        <Flex flexDir="column" w={!collapsed ? "80%" : undefined}>
          <Text fontWeight="bold" fontSize="16px" color={colors.black}>
            {titleCard}
          </Text>
        </Flex>

        <Box ml={!collapsed ? "16px" : "auto"}>
          {collapsed ? (
            <BsChevronDown fontSize={20} />
          ) : (
            <BsChevronUp fontSize={20} />
          )}
        </Box>
      </Flex>
      <Collapse in={!collapsed}>
        <Box overflow="visible" pt={4} px={0.5}>
          {children}
        </Box>
      </Collapse>
    </CardDefault>
  );
}
